import React, { useEffect, useState } from "react";
import { Dropdown, Space, Card } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SidenavTag, InProgress, FollowUp } from "../../../../../assets/svg";
import UserService from "../../../../../service/UserService";
import { activePatientSagaAction } from "../../../../../sagas/saga-actions";
import { setPopup } from "../../../../../actions/popupAction";

import "./styles.scss";
import CustomButton from "../../../../../components/customButton";
import useWindowDimensions from "../../../../../components/custom-hooks/useWindowDimensions";
import { MOBILE_WIDTH } from "../../../../../constants/constants";

const TagComp = (props) => {
  const { tags, user, conversation_tag, filteredTag } = props;
  const userService = new UserService();

  const [tag, setTag] = useState();
  const [visible, setVisible] = useState(false);
  const [opened, setOpened] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [NoneTag, setNoneTag] = useState(false);
  const { width } = useWindowDimensions();

  useEffect(
    () => {
      setTag(conversation_tag);
    },
    [conversation_tag]
  );

  const onTagSelect = (e) => {
    setTag(e);
    setVisible(true);
    setOpened(true);
    setIsButtonDisabled(false);
    setNoneTag(true);
  };

  const tagPatient = async () => {
    const data = {
      tagId: tag.id,
      patientId: props.patient,
    };
    try {
      const tagResponse = await userService.tagPatient(data);
      setVisible(!visible);
      if (tagResponse?.data.success === true) {
        props.setPopup({
          customPopupMessage: true,
          messageType: "success",
          message: tagResponse.data.message,
        });
      }
      if (user?.id) {
        const obj = {
          offset: 0,
          userId: user.id,
          tag: filteredTag,
        };
        props.activePatientSagaAction(obj);
      }
    } catch (e) {
      props.setPopup({
        customPopupMessage: true,
        messageType: "error",
        message: "Something went wrong.",
      });
    }
  };
  const applyTag = async () => {
    if (tag) {
      tagPatient();
    } else {
      unTaging(props.patient);
    }
  };

  const change = () => {
    if (!opened) {
      setVisible(true);
      setOpened(true);
      setNoneTag(null);
      setIsButtonDisabled(true);
    }
    if (opened) {
      setVisible(false);
      setOpened(false);
      setTag(conversation_tag);
    }
  };

  const unTaging = async (id) => {
    try {
      const unTagResponse = await userService.untagPatient(id);
      if (unTagResponse?.data.success === true) {
        props.setPopup({
          customPopupMessage: true,
          messageType: "success",
          message: unTagResponse.data.message,
        });
      }
      if (user?.id) {
        const obj = {
          offset: 0,
          userId: user.id,
          tag: filteredTag,
        };
        props.activePatientSagaAction(obj);
      }
    } catch (e) {
      props.setPopup({
        customPopupMessage: true,
        messageType: "error",
        message: "Something went wrong.",
      });
    }
    setVisible(false);
  };

  let items = tags?.map((e) => ({
    key: e.id,
    label: (
      <li
        onClick={(event) => {
          event.stopPropagation();
          onTagSelect(e);
        }}
        className={e?.id === tag?.id ? "selected-tag" : ""}
      >
        {e.tagName}
        {e.tagName === "Follow Up" && (
          <span className="followupDot">{FollowUp}</span>
        )}
        {e.tagName === "In Progress" && (
          <span className="inprogressDot">{InProgress}</span>
        )}
      </li>
    ),
  }));
  if (conversation_tag?.id) {
    items = [
      {
        key: "none",
        label: (
          <li
            className={!tag && NoneTag ? "selected-tag" : ""}
            onClick={(event) => {
              event.stopPropagation();
              onTagSelect();
            }}
          >
            None
          </li>
        ),
      },
      ...items,
    ];
  }

  const renderDrop = (menu) => (
    <div onClick={(e) => e.stopPropagation()}>
      {" "}
      <Card title="Tags">
        <>
          {React.cloneElement(menu, { className: "ant-card-head" })}
          <CustomButton
            title="Apply"
            disabled={isButtonDisabled}
            className="tag-Apply-btn"
            type="primary"
            onClick={(e) => {
              e.stopPropagation();
              applyTag();
            }}
          />
        </>
      </Card>
    </div>
  );
  return (
    <Dropdown
      menu={{ items, className: "ant-card-body" }}
      placement="bottomRight"
      onOpenChange={change}
      visible={visible}
      trigger={width > MOBILE_WIDTH ? ["hover"] : ["click"]}
      dropdownRender={renderDrop}
    >
      <Space onClick={(e) => e.stopPropagation()}>
        {" "}
        <SidenavTag />{" "}
      </Space>
    </Dropdown>
  );
};

const mapStateToProps = (state) => ({
  activePatient: state.activePatient,
});

const mapDispatchToProps = (dispatch) => {
  return {
    activePatientSagaAction: bindActionCreators(
      activePatientSagaAction,
      dispatch
    ),
    setPopup: (data) => dispatch(setPopup(data)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TagComp);
